let observer = null

export default {
  inserted (el, binding) {
    const handleIntersect = (entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          binding.value?.()
          if (binding.modifiers.once) observer.unobserve(el)
        }
      })
    }

    const createObserver = () => {
      observer = new IntersectionObserver(handleIntersect, {
        root: null,
        threshold: 0
      })
      observer.observe(el)
    }
    createObserver()
  },
  unbind (el) {
    observer?.unobserve(el)
  }
}
